import type { CaseFormUIFields } from "@/Pages/Cases/components/Forms/common/CaseFormUIFields";
import type { TwiageCase } from "@/App/types/TwiageCase";
import type { DataEnabledTag } from "@/App/types/twiageTypes";
import { saveDataEnabledTags } from "@/Pages/Cases/functions/tags/saveDataEnabledTags";

export const handleDataEnabledTags = (payload: CaseFormUIFields, selectedCase: TwiageCase | null): void => {
  if (!payload?.dataEnabledTags) return;

  const existingTags = selectedCase?.dataEnabledTags ?? [];
  const tagsMap = new Map(existingTags.map((tag) => [tag.id, tag]));

  const changedTags = payload.dataEnabledTags.filter((tag): tag is DataEnabledTag => {
    if (!hasValidStructure(tag)) return false;

    const existingTag = tagsMap.get(tag.id);
    if (!existingTag) return true;

    const newValue = getFirstValue(tag);
    const existingValue = getFirstValue(existingTag);

    return !newValue || !existingValue || newValue !== existingValue;
  });

  if (changedTags.length > 0 && selectedCase?.id) {
    saveDataEnabledTags(changedTags, selectedCase.id);
  }
};

const hasValidStructure = (tag: DataEnabledTag): boolean => {
  return Array.isArray(tag.values) && tag.values.length > 0;
};

const getFirstValue = (tag: DataEnabledTag): string | undefined => {
  return tag.values?.[0]?.fields?.[0]?.value;
};
